var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_organization",
          attrs: {
            id: "modal-organization",
            title: _vm.title,
            size: "xl",
            lazy: "",
            centered: "",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-footer": ""
          },
          on: { hidden: _vm.onHidden }
        },
        [
          _c("b-skeleton-wrapper", {
            attrs: { loading: _vm.isBusy },
            scopedSlots: _vm._u([
              {
                key: "loading",
                fn: function() {
                  return [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-card",
                          { attrs: { "bg-variant": "light" } },
                          [
                            _c(
                              "b-row",
                              { staticClass: "mt-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "10%", height: "24%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "10%", height: "24%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "10%", height: "24%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      attrs: { width: "16%", height: "115%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "20%", height: "17%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "29%"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { width: "30%", height: "13%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "15%", height: "17%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "29%"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { width: "26%", height: "13%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "4%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "6%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-5" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "9%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "104%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-1" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      attrs: { width: "15%", height: "55%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "6%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "49%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-3" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "19%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "28%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-0" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "35%", height: "50%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "43%", height: "21%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "50%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "26%", height: "21%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "50%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "30%", height: "21%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "50%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "20%", height: "21%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "50%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "20%", height: "21%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "50%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-card",
                          { attrs: { "bg-variant": "light" } },
                          [
                            _c(
                              "b-row",
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-inn",
                                          label: _vm.$t(
                                            "message.organizations.modal.inn"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            disabled: _vm.isDisabled,
                                            state: _vm.getFieldState("inn"),
                                            placeholder: "Введите ИНН"
                                          },
                                          model: {
                                            value: _vm.newItem.inn,
                                            callback: function($$v) {
                                              _vm.$set(_vm.newItem, "inn", $$v)
                                            },
                                            expression: "newItem.inn"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-kpp",
                                          label: _vm.$t(
                                            "message.organizations.modal.kpp"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            disabled: _vm.isDisabled,
                                            placeholder: "Введите КПП"
                                          },
                                          model: {
                                            value: _vm.newItem.kpp,
                                            callback: function($$v) {
                                              _vm.$set(_vm.newItem, "kpp", $$v)
                                            },
                                            expression: "newItem.kpp"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-ogrn",
                                          label: _vm.$t(
                                            "message.organizations.modal.ogrn"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            disabled: _vm.isDisabled,
                                            placeholder: "Введите ОГРН"
                                          },
                                          model: {
                                            value: _vm.newItem.ogrn,
                                            callback: function($$v) {
                                              _vm.$set(_vm.newItem, "ogrn", $$v)
                                            },
                                            expression: "newItem.ogrn"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "mb-2",
                                attrs: {
                                  size: "sm",
                                  disabled:
                                    _vm.isEmpty(_vm.newItem.inn) ||
                                    _vm.isDisabled,
                                  variant: "secondary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.findCustomerData()
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "mr-1",
                                  attrs: { icon: "file-signature" }
                                }),
                                _vm._v(
                                  "\n              Заполнить данными\n            "
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-name",
                                  label: _vm.$t(
                                    "message.organizations.modal.nameInput"
                                  ),
                                  description: _vm.$t(
                                    "message.organizations.modal.nameInputDescription"
                                  )
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    size: "sm",
                                    disabled: _vm.isDisabled,
                                    state: _vm.getFieldState("name")
                                  },
                                  model: {
                                    value: _vm.newItem.name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "name", $$v)
                                    },
                                    expression: "newItem.name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-full-name",
                                  label: _vm.$t(
                                    "message.organizations.modal.fullNameInput"
                                  ),
                                  description: _vm.$t(
                                    "message.organizations.modal.fullNameInputDescription"
                                  )
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    size: "sm",
                                    disabled: _vm.isDisabled
                                  },
                                  model: {
                                    value: _vm.newItem.full_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "full_name", $$v)
                                    },
                                    expression: "newItem.full_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-address",
                                  label: _vm.$t(
                                    "message.organizations.modal.addressInput"
                                  )
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    size: "sm",
                                    disabled: _vm.isDisabled,
                                    placeholder: _vm.$t(
                                      "message.organizations.modal.addressPlaceholder"
                                    )
                                  },
                                  model: {
                                    value: _vm.newItem.address,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "address", $$v)
                                    },
                                    expression: "newItem.address"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-phone",
                                  label: _vm.$t(
                                    "message.organizations.modal.phoneInput"
                                  )
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    size: "sm",
                                    disabled: _vm.isDisabled,
                                    placeholder: _vm.$t(
                                      "message.organizations.modal.phonePlaceholder"
                                    ),
                                    "aria-describedby": "inputLiveFeedbackPhone"
                                  },
                                  model: {
                                    value: _vm.newItem.phone,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "phone", $$v)
                                    },
                                    expression: "newItem.phone"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-form-invalid-feedback",
                                  { attrs: { id: "inputLiveFeedbackPhone" } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.organizations.modal.phoneError"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-description",
                                  label: _vm.$t(
                                    "message.organizations.modal.descriptionInput"
                                  )
                                }
                              },
                              [
                                _c("b-form-textarea", {
                                  attrs: {
                                    size: "sm",
                                    disabled: _vm.isDisabled,
                                    placeholder: _vm.$t(
                                      "message.organizations.modal.descriptionPlaceholder"
                                    ),
                                    rows: 3,
                                    "max-rows": 6
                                  },
                                  model: {
                                    value: _vm.newItem.description,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "description", $$v)
                                    },
                                    expression: "newItem.description"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("h6", [_vm._v("Банковские реквизиты")]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              {
                                staticClass: "align-items-end",
                                attrs: { cols: "2" }
                              },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-bik",
                                          label: _vm.$t(
                                            "message.organizations.modal.bik"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.bik,
                                            callback: function($$v) {
                                              _vm.$set(_vm.newItem, "bik", $$v)
                                            },
                                            expression: "newItem.bik"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-cor-account",
                                          label: _vm.$t(
                                            "message.organizations.modal.cor_account"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.cor_account,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "cor_account",
                                                $$v
                                              )
                                            },
                                            expression: "newItem.cor_account"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-bank",
                                          label: _vm.$t(
                                            "message.organizations.modal.bank"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "input-bank",
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.bank,
                                            callback: function($$v) {
                                              _vm.$set(_vm.newItem, "bank", $$v)
                                            },
                                            expression: "newItem.bank"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-checking-account",
                                          label: _vm.$t(
                                            "message.organizations.modal.checking_account"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "input-checking-account",
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.checking_account,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "checking_account",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "newItem.checking_account"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("h6", [
                              _vm._v(
                                "Руководители организации или ИП для документов"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              {
                                staticClass: "align-items-end",
                                attrs: { cols: "2" }
                              },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-director",
                                          label: _vm.$t(
                                            "message.organizations.modal.director"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.director,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "director",
                                                $$v
                                              )
                                            },
                                            expression: "newItem.director"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-accountant",
                                          label: _vm.$t(
                                            "message.organizations.modal.accountant"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.accountant,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "accountant",
                                                $$v
                                              )
                                            },
                                            expression: "newItem.accountant"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("h6", [_vm._v("Интеграции")]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "align-items-end" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-balans-pro",
                                          label: "Баланс Про API токен"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value:
                                              _vm.integrations
                                                .balans_pro_org_token,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.integrations,
                                                "balans_pro_org_token",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "integrations.balans_pro_org_token"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-avito-client-id",
                                          label: "Avito client id"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value:
                                              _vm.integrations.avito_client_id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.integrations,
                                                "avito_client_id",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "integrations.avito_client_id"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-avito-client-secret",
                                          label: "Avito client secret"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value:
                                              _vm.integrations
                                                .avito_client_secret,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.integrations,
                                                "avito_client_secret",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "integrations.avito_client_secret"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "b-link",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle:stamp-collapse",
                                    arg: "stamp-collapse"
                                  }
                                ],
                                staticClass: "text-decoration-none"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "when-open" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "chevron-up" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "when-closed" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "chevron-down" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "stamp" }
                                }),
                                _vm._v(
                                  " Логотип, печать, подписи\n            "
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-collapse",
                              { attrs: { id: "stamp-collapse" } },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "mt-2 text-small text-danger"
                                  },
                                  [
                                    _vm._v(
                                      "Все файлы должны быть соответствующего размера в форматах "
                                    ),
                                    _c("b", [_vm._v(".jpeg")]),
                                    _vm._v(" или "),
                                    _c("b", [_vm._v(".png")])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-2 mb-2" },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-card",
                                          {
                                            staticClass: "text-center",
                                            attrs: { "no-body": "" }
                                          },
                                          [
                                            _c("b-card-header", [
                                              _vm._v(
                                                "\n                      Лого (54x27 мм)\n                    "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-card-body",
                                              [
                                                _c("b-img", {
                                                  attrs: {
                                                    thumbnail: "",
                                                    width: "100",
                                                    height: "100",
                                                    src: _vm.logoBlobURL
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-card-footer",
                                              [
                                                _c(
                                                  "b-list-group",
                                                  { attrs: { horizontal: "" } },
                                                  [
                                                    _c("b-form-file", {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isDisabled,
                                                        size: "sm",
                                                        accept:
                                                          "image/jpeg, image/png",
                                                        "browse-text":
                                                          "Выбрать",
                                                        placeholder:
                                                          "Файл не выбран"
                                                      },
                                                      model: {
                                                        value: _vm.logoFile,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.logoFile = $$v
                                                        },
                                                        expression: "logoFile"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            _vm.isDisabled,
                                                          size: "sm",
                                                          variant: "danger"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onRemove(
                                                              "logoFile"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "times"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-card",
                                          {
                                            staticClass: "text-center",
                                            attrs: { "no-body": "" }
                                          },
                                          [
                                            _c("b-card-header", [
                                              _vm._v(
                                                "\n                      Печать (40x40 мм)\n                    "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-card-body",
                                              [
                                                _c("b-img", {
                                                  attrs: {
                                                    thumbnail: "",
                                                    width: "100",
                                                    height: "100",
                                                    src: _vm.stampBlobURL
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-card-footer",
                                              [
                                                _c(
                                                  "b-list-group",
                                                  { attrs: { horizontal: "" } },
                                                  [
                                                    _c("b-form-file", {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isDisabled,
                                                        size: "sm",
                                                        accept:
                                                          "image/jpeg, image/png",
                                                        "browse-text":
                                                          "Выбрать",
                                                        placeholder:
                                                          "Файл не выбран"
                                                      },
                                                      model: {
                                                        value: _vm.stampFile,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.stampFile = $$v
                                                        },
                                                        expression: "stampFile"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            _vm.isDisabled,
                                                          size: "sm",
                                                          variant: "danger"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onRemove(
                                                              "stampFile"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "times"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-card",
                                          {
                                            staticClass: "text-center",
                                            attrs: { "no-body": "" }
                                          },
                                          [
                                            _c("b-card-header", [
                                              _vm._v(
                                                "\n                      Подпись руководителя (34x16 мм)\n                    "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-card-body",
                                              [
                                                _c("b-img", {
                                                  attrs: {
                                                    thumbnail: "",
                                                    width: "100",
                                                    height: "100",
                                                    src: _vm.directorSignBlobURL
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-card-footer",
                                              [
                                                _c(
                                                  "b-list-group",
                                                  { attrs: { horizontal: "" } },
                                                  [
                                                    _c("b-form-file", {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isDisabled,
                                                        size: "sm",
                                                        accept:
                                                          "image/jpeg, image/png",
                                                        "browse-text":
                                                          "Выбрать",
                                                        placeholder:
                                                          "Файл не выбран"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.directorSignFile,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.directorSignFile = $$v
                                                        },
                                                        expression:
                                                          "directorSignFile"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            _vm.isDisabled,
                                                          size: "sm",
                                                          variant: "danger"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onRemove(
                                                              "directorSignFile"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "times"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-card",
                                          {
                                            staticClass: "text-center",
                                            attrs: { "no-body": "" }
                                          },
                                          [
                                            _c("b-card-header", [
                                              _vm._v(
                                                "\n                      Подпись бухгалтера (34x16 мм)\n                    "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-card-body",
                                              [
                                                _c("b-img", {
                                                  attrs: {
                                                    thumbnail: "",
                                                    width: "100",
                                                    height: "100",
                                                    src:
                                                      _vm.accountantSignBlobURL
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-card-footer",
                                              [
                                                _c(
                                                  "b-list-group",
                                                  { attrs: { horizontal: "" } },
                                                  [
                                                    _c("b-form-file", {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isDisabled,
                                                        size: "sm",
                                                        accept:
                                                          "image/jpeg, image/png",
                                                        "browse-text":
                                                          "Выбрать",
                                                        placeholder:
                                                          "Файл не выбран"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.accountantSignFile,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.accountantSignFile = $$v
                                                        },
                                                        expression:
                                                          "accountantSignFile"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            _vm.isDisabled,
                                                          size: "sm",
                                                          variant: "danger"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onRemove(
                                                              "accountantSignFile"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "times"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-card",
                                          {
                                            staticClass: "text-center",
                                            attrs: { "no-body": "" }
                                          },
                                          [
                                            _c("b-card-header", [
                                              _vm._v(
                                                "\n                      Подпись ИП (34x16 мм)\n                    "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-card-body",
                                              [
                                                _c("b-img", {
                                                  attrs: {
                                                    thumbnail: "",
                                                    width: "100",
                                                    height: "100",
                                                    src:
                                                      _vm.individualSignBlobURL
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-card-footer",
                                              [
                                                _c(
                                                  "b-list-group",
                                                  { attrs: { horizontal: "" } },
                                                  [
                                                    _c("b-form-file", {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isDisabled,
                                                        size: "sm",
                                                        accept:
                                                          "image/jpeg, image/png",
                                                        "browse-text":
                                                          "Выбрать",
                                                        placeholder:
                                                          "Файл не выбран"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.individualSignFile,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.individualSignFile = $$v
                                                        },
                                                        expression:
                                                          "individualSignFile"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            _vm.isDisabled,
                                                          size: "sm",
                                                          variant: "danger"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onRemove(
                                                              "individualSignFile"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "times"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          [
            _c(
              "div",
              { staticClass: "w-100 d-flex justify-content-end py-2" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "mr-2",
                    attrs: { size: "sm", variant: "secondary" },
                    on: { click: _vm.handleCancel }
                  },
                  [_vm._v("\n          Отменить\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: {
                      size: "sm",
                      variant: "success",
                      disabled: _vm.isDisabled || _vm.loading
                    },
                    on: { click: _vm.handleOk }
                  },
                  [
                    _vm.loading
                      ? _c("b-spinner", { attrs: { small: "" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("font-awesome-icon", {
                      staticClass: "mr-1",
                      attrs: { icon: "save" }
                    }),
                    _vm._v("\n          Сохранить\n        ")
                  ],
                  1
                )
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2af072dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2af072dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organizations/Organization.vue
// module id = null
// module chunks = 